import PropTypes from 'prop-types'
import React from 'react'
import Select from 'components/UI/Select'
import { connect } from 'react-redux'
import { setRegionForExternalRegion } from 'actions/Regions'
import { withTranslation } from 'react-i18next'

const RegionDropDown = ({ selectOption, selectOptions, dispatch, t, redirect }) => {
    if (selectOptions.length === 0) {
        return null
    }

    return (
        <React.Fragment>
            <h3>{t('regionDropDownTitle')}</h3>
            <Select
                option={selectOption}
                options={selectOptions}
                onChange={(payload) => dispatch(setRegionForExternalRegion(payload, redirect))}
            />
        </React.Fragment>
    )
}

RegionDropDown.propTypes = {
    selectOption: PropTypes.object,
    selectOptions: PropTypes.array,
    redirect: PropTypes.bool,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

const mapStateToProps = ({ region }) => {
    const selectOption = { value: region.slug || '', label: region.name || '' }

    const selectOptions = region.regions.map((r) => {
        return { value: r.externalRegion, label: r.name }
    })

    return {
        selectOption,
        selectOptions,
    }
}

export default connect(mapStateToProps)(withTranslation()(RegionDropDown))
